import axios from 'axios';
import { HppLeadProducts, ListProduct, PipelineAttachment } from '../interfaces/Pipeline';
import { ProductLog } from '../interfaces/Log';

const API_URL = process.env.REACT_APP_API_URL;

const LOG = `${API_URL}lead_log`;
const SEND_REPORT_LOG = `${API_URL}generated-report`;

interface TypeAttachment {
  name: string,
  url: string
}

export interface CustomFieldType {
  [key: string]: any
}

export const insertLog = async (
  leadId: string,
  description: string,
  leadProgressId: string,
  subProgressId: string,
  token: string,
  attachments?: TypeAttachment[],
  leadProducts?: HppLeadProducts[],
  customFields?: CustomFieldType
) => {
  return axios.post(
    LOG,
    {
      description,
      leadId,
      leadProgressId,
      subProgressId,
      attachments,
      leadProducts,
      customFields
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  );
};

export interface UpdateDescriptionLogProps {
  id: string
  leadId: string,
  description: string,
  leadProgressId: string,
  // subProgressId: string,
  token: string,
  attachments?: TypeAttachment[],
  // leadProducts?: HppLeadProducts[],
  // customFields?: CustomFieldType
}

export const updateDescriptionLog = async (
  {
    id,
    leadId,
    description,
    leadProgressId,
    // subProgressId,
    attachments,
    // leadProducts,
    // customFields,
    token
  }: UpdateDescriptionLogProps) => {
  return axios.put(`${API_URL}lead_log?logId=${id}`, {
    leadId,
    description,
    leadProgressId,
    // subProgressId,
    attachments,
    // leadProducts,
    // customFields,
  }, {
    headers: {
      'X-Auth-token': token,
    },
  })
}

export const sendReportLog = async (
  receiversId: string[],
  fileName: string,
  fileUrl: string,
  fileMimeType: string,
  token: string
) => {
  return axios.post(
    SEND_REPORT_LOG,
    {
      receiversId,
      fileName,
      fileUrl,
      fileMimeType,
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  );
};

export const getCustomFieldLog = async (leadId: string, progressId: string, token: string) => {
  return axios.get(`${API_URL}/lead_logs/custom-field?lead_id=${leadId}&progress_id=${progressId}`, {
    headers: {
      'X-Auth-token': token,
    },
  });
}

export const readNotificationUser = async (id: string, token: string) => {
  return axios.put(`${API_URL}crm-notifications/${id}/read`, {}, {
    headers: {
      'X-Auth-token': token,
    },
  });
}

export const readAllNotificationUser = async (token: string) => {
  return axios.post(`${API_URL}crm-notifications/read-all`, {}, {
    headers: {
      'X-Auth-token': token,
    },
  });
}

// Api to get all user in the company
export const getAllUserCompany = async (token: string) => {
  const response = await axios.get(`${API_URL}user/company`, {
    headers: {
      'X-Auth-token': token,
    },
  });
  return response.data.data
}

export const getUserByleadId = async (leadId: string, token: string) => {
  const response = await axios.get(`${API_URL}user-lead?leadId=${leadId}`, {
    headers: {
      'X-Auth-token': token,
    },
  });
  return response.data.data
}
